import { reduce, map, some } from 'lodash';

import { MEDIA_STREAM_TYPES } from 'playable/dist/src';
import { PRODUCTION_HOSTS } from '@wix/wix-vod-constants/env';
import {
  getResizedImageUrl,
  isSubscriptionEnabled,
} from '@wix/wix-vod-shared/common';

function toVidiTypes(url, type) {
  if (/mp4/i.test(type)) {
    return {
      url,
      type: MEDIA_STREAM_TYPES.MP4,
      name: /[0-9]+p/i.exec(type)[0],
    };
  }
  if (/mpd/i.test(type)) {
    return { url, type: MEDIA_STREAM_TYPES.DASH };
  }
  if (/m3u8/i.test(type)) {
    return { url, type: MEDIA_STREAM_TYPES.HLS };
  }
  if (/webm/i.test(type)) {
    return { url, type: MEDIA_STREAM_TYPES.WEBM };
  }
  return null;
}

export const getQueryParameters = () => {
  const paramsPairs = window.location.search.replace(/^\?/, '').split('&');
  return reduce(
    paramsPairs,
    (acc, param) => {
      const [key, value] = param.split('=');
      if (key) {
        acc[key] = decodeURIComponent(value);
      }
      return acc;
    },
    {},
  );
};

export const parseVidiUrls = (videoUrls) => map(videoUrls, toVidiTypes);
export const hasEnabledDealInfo = (dealInfo) =>
  some(dealInfo, (info) => info.enabled);
export const isFreeVideo = (videoItem) =>
  !hasEnabledDealInfo(videoItem.dealInfo);
export const isChannelSubscriptionOnly = (channelData) =>
  isSubscriptionEnabled(channelData) && channelData.subscriptionOnly;

export const fitImage = (logoUrl, width, height) => {
  if (!logoUrl) {
    return null;
  }

  return getResizedImageUrl({
    url: logoUrl,
    width,
    height,
    mode: 'fit',
    imageHost: PRODUCTION_HOSTS.image,
  });
};

export const isMobile = () =>
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  );

export const normalizeId = (id) => id && id.split('-').pop();
